(function($) {

    var supporterFormValid = true;
    var supporterFormNextStep = $('.supporter-form-next-step');
    var supporterFormSubmit = $('.supporter-form-submit');
    var requiredFields = $('.supporter-form-wrap .required');
    var amountField = $('[name=supporter-amount]');

    supporterFormNextStep.on('click', function() {
        supporterFormValid = true;
        $('.supporter-form-wrap .input-wrap').removeClass('has-error');
        $('.supporter-form-wrap .input-wrap .input-error').hide();
        $('#supporter-agree').parent().removeClass('has-error');

        requiredFields.each(function (ind, val) {
            if ($(val).val() === '') {
                supporterFormValid = false;
                $(val).parent().addClass('has-error').find('.input-error').show();
            }

            if ($(val).attr('name') === 'supporter-code') {
                if ($(val).val().length !== 11) {
                    supporterFormValid = false;
                    $(val).parent().addClass('has-error').find('.input-error').show();
                }
            }

            if (!$('#supporter-agree').is(':checked')) {
                supporterFormValid = false;
                $('#supporter-agree').parent().addClass('has-error');
            }
        });

        if (supporterFormValid) {
            $('.content-switcher .content-switch').removeClass('active');
            $('.content-switcher .content-switch[data-tab=2]').addClass('active');

            $('.content-tab').removeClass('active');
            $('.content-tab-2').addClass('active');

            $('html, body').animate({scrollTop: 0}, 400);
        } else {
            $('html, body').animate({scrollTop: $('body').find('.has-error').offset().top - 200}, 400);
        }
    });

    if (amountField.val()) {
        supporterFormSubmit.html('Paremti — ' + amountField.val() + ' €');
    }

    amountField.on('keyup', function () {
        if (amountField.val()) {
            supporterFormSubmit.html('Paremti — ' + amountField.val() + ' €');
        } else {
            supporterFormSubmit.html('Paremti');
        }
    });

    supporterFormSubmit.on('click', function () {
        supporterFormSubmit.addClass('loading');

        amountField.parent().removeClass('has-error').find('.input-error').hide();

        if (amountField.val() === '') {
            supporterFormValid = false;
            amountField.parent().addClass('has-error').find('.input-error').show();
            supporterFormSubmit.removeClass('loading');
        } else {
            var data = {
                'action' : 'get_supporter_link',
                'amount' : amountField.val(),
                'method' : $('[name=payment]:checked').val(),
                'name' : $('[name=supporter-name]').val(),
                'surname' : $('[name=supporter-surname]').val(),
                'code' : $('[name=supporter-code]').val(),
                'email' : $('[name=supporter-email]').val(),
            };

            $.get(postmpwp.ajax_url, data, function(response){
                if (response.success) {
                    window.location = response.data;
                }
            });
        }
    });

})( jQuery );